export const salesMode = {
  pickup: 'PICK_UP_IN_STORE',
  shipping: 'SHIPPING_FROM_STORE',
  marketplace: 'MARKETPLACE',
  standard: 'STANDARD_DELIVERY',
};

export enum QuestionType {
  Store = 'STORE',
  Carrier = 'CARRIER',
  Transfer = 'TRANSFER',
}
